module.exports = __webpack_public_path__ + "e6a83b33bca9b3ddd96a2417eaf78f2b.svg";